// import { useEffect, useState } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import { Icon } from "leaflet";

// const driverIcon = new Icon({
//   iconUrl: "https://cdn-icons-png.flaticon.com/512/854/854894.png",
//   iconSize: [40, 40],
// });

// interface Props {
//   apiUrl: string;
// }

// export default function LiveLocationTracker({ apiUrl }: Props) {
//   const [location, setLocation] = useState<{ lat: number; lng: number } | null>(
//     null
//   );

//   const fetchLocation = async () => {
//     try {
//       const res = await fetch(apiUrl);
//       const data = await res.json();

//       // For ISS API
//       const lat = data?.iss_position?.latitude || data?.latitude;
//       const lng = data?.iss_position?.longitude || data?.longitude;

//       if (lat && lng) {
//         setLocation({
//           lat: parseFloat(lat),
//           lng: parseFloat(lng),
//         });
//       }
//     } catch (err) {
//       console.error("API ERROR:", err);
//     }
//   };

//   useEffect(() => {
//     fetchLocation(); // first call
//     const interval = setInterval(fetchLocation, 3000); // update every 3s
//     return () => clearInterval(interval);
//   }, []);

//   // ❗ SAFE RENDERING FIX
//   if (!location) return <p>Loading live location...</p>;

//   return (
//     <MapContainer
//       center={location}
//       zoom={15}
//       style={{ height: "200px", width: "100%" }}
//     >
//       <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

//       <Marker position={location} icon={driverIcon}>
//         <Popup>Delivery Partner Live</Popup>
//       </Marker>
//     </MapContainer>
//   );
// }


import { useEffect, useState, useCallback } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

interface Props {
  latitude?: string;
  longitude?: string;
}

// ✅ Custom Driver Icon
const driverIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/854/854894.png",
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

export default function LiveLocationTracker({ latitude, longitude }: Props) {
  const [location, setLocation] = useState<{ lat: number; lng: number } | null>(null);
  const [loading, setLoading] = useState(true);

  const parseLocation = useCallback(() => {
    if (latitude && longitude) {
      const lat = parseFloat(latitude);
      const lng = parseFloat(longitude);
      
      if (!isNaN(lat) && !isNaN(lng)) {
        setLocation({ lat, lng });
        setLoading(false);
        return;
      }
    }
    // ✅ Fallback to API default coordinates (Kochi, Kerala)
    setLocation({ lat: 10.911745, lng: 76.4215296 });
    setLoading(false);
  }, [latitude, longitude]);

  useEffect(() => {
    parseLocation();
  }, [parseLocation]);

  // ✅ Loading State
  if (loading) {
    return (
      <div style={{ 
        height: "200px", 
        width: "100%", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        border: "1px solid #e0e0e0"
      }}>
        <div>Loading live location...</div>
      </div>
    );
  }

  // ✅ Error State
  if (!location) {
    return (
      <div style={{ 
        height: "200px", 
        width: "100%", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        backgroundColor: "#ffebee",
        borderRadius: "8px",
        border: "1px solid #f44336",
        color: "#d32f2f"
      }}>
        <div>Location not available</div>
      </div>
    );
  }

  return (
    <div style={{ height: "200px", width: "100%", borderRadius: "8px", overflow: "hidden" }}>
      <MapContainer
        center={[location.lat, location.lng]}
        zoom={15}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer 
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={[location.lat, location.lng]} icon={driverIcon}>
          <Popup>
            <div style={{ minWidth: "150px" }}>
              <strong>🚚 Delivery Partner Live</strong><br/>
              📍 Lat: {location.lat.toFixed(6)}<br/>
              📍 Lng: {location.lng.toFixed(6)}<br/>
              <small>{latitude}, {longitude}</small>
            </div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}
